import { render, staticRenderFns } from "./ListasDeCorreo.vue?vue&type=template&id=867b2c10&scoped=true&"
import script from "./ListasDeCorreo.vue?vue&type=script&lang=js&"
export * from "./ListasDeCorreo.vue?vue&type=script&lang=js&"
import style0 from "./ListasDeCorreo.vue?vue&type=style&index=0&id=867b2c10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867b2c10",
  null
  
)

export default component.exports